import { StepIndicatorItemViewModel } from './step-indicator-item.viewmodel';

export abstract class StepIndicatorViewModel<
    TStep extends string,
    TItemViewModel extends StepIndicatorItemViewModel<TStep>
> {
    public readonly selectedStep: TItemViewModel;

    constructor(
        public readonly baseRoute: string[],
        public readonly steps: TItemViewModel[],
        public readonly selectedStepId: TStep
    ) {
        const selectedStep = steps.find(
            (step) => step.stepId === selectedStepId
        );

        if (!selectedStep) {
            throw new Error('The selected step does not exist');
        }

        if (selectedStep.isVisible === false) {
            throw new Error('The selected step has to be visible');
        }

        if (selectedStep.isDisabled) {
            throw new Error('The selected step has to be enabled');
        }

        this.selectedStep = selectedStep;
    }
}
